(function () {
  var fmt = function (pence) {
    return '£' + (pence / 100).toFixed(2);
  };

  document.querySelectorAll('.prodcard-card[data-url]').forEach(function (card) {
    var rawUrl    = card.dataset.url;
    var parsed    = new URL(rawUrl);
    var parts     = parsed.pathname.split('/');
    var handle    = parts[parts.length - 1];
    var variantId = parsed.searchParams.get('variant')
                    ? parseInt(parsed.searchParams.get('variant'), 10)
                    : null;

    var imgEl     = card.querySelector('.prodcard-img-wrap img');
    var titleEl   = card.querySelector('.prodcard-title');
    var saleEl    = card.querySelector('.prodcard-price-sale');
    var origEl    = card.querySelector('.prodcard-price-orig');
    var savingEl  = card.querySelector('.prodcard-saving');
    var badgeEl   = card.querySelector('.prodcard-badge');
    var btnEl     = card.querySelector('.prodcard-btn');

    // Set the buy button href from the original URL
    btnEl.href = rawUrl;

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        // Title — only overwrite if the element is empty; lets you pre-fill it in HTML
        if (!titleEl.textContent.trim()) { titleEl.textContent = product.title; }

        // Image — only set from Shopify if src is not already provided in the HTML
        if (!imgEl.getAttribute('src')) {
          var imgSrc = product.featured_image || (product.images && product.images[0]);
          if (imgSrc) { imgEl.src = imgSrc; }
        }
        if (!imgEl.getAttribute('alt')) { imgEl.alt = product.title; }

        // Variant — match by ID, or fall back to first
        var variant = variantId
          ? (product.variants.find(function (v) { return v.id === variantId; }) || product.variants[0])
          : product.variants[0];

        var price   = variant.price;
        var compare = variant.compare_at_price;

        saleEl.textContent = fmt(price);
        saleEl.classList.remove('prodcard-loading');

        if (compare && compare > price) {
          var saving = Math.round((1 - price / compare) * 100);
          origEl.textContent     = fmt(compare);
          origEl.style.display   = 'inline';
          savingEl.textContent   = 'Save up to ' + saving + '%';
          savingEl.style.display = 'block';
          badgeEl.style.display  = 'block';
        }
      })
      .catch(function () {
        saleEl.textContent = 'See price';
        saleEl.classList.remove('prodcard-loading');
        titleEl.textContent = 'View product';
      });
  });
})();
